module.exports = __webpack_public_path__ + "img/guest_nav.1e3f3eb4.png";